import { Translate } from 'react-translatify'

export default {
	context: {
		translate: Translate
	}
}



// WEBPACK FOOTER //
// ./src/utilities/translationHelper.js